import React from "react";
import TipoEnderecoService from "../../services/TipoEnderecoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaTipoEndereco extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: TipoEnderecoService,
            labels: {
                title: 'Lista de Tipo(s) de Endereço(s)',
                btnNewRegister: 'Tipo de Endereço',
            },
            keyItem: 'idTipoEndereco',
            urlForm: '/CadTipoEndereco',
            itensFilter: ["idTipoEndereco", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idTipoEndereco}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}